import type { Config } from '@dvb/common';

import { baseAxios } from '@milestone-portal/api/client';

export const getSystemConfigRequest = async () => {
  const { data } = await baseAxios.get<Config>(
    '/api/milestone/v1/system/config'
  );
  return data;
};
